import { useAccountStore } from '@/store/modules/account/store.js';
import { useGlobalStore } from '@/store/store.ts';
import { useContextStore } from '@/store/modules/context/store.ts';
import { useAccountCardStore } from '@/store/modules/accountCard/store.js';
import { useAssociatedLeadsStore } from '@/store/modules/associatedLeads/store.js';
import { useCalendarStore } from '@/store/modules/calendar/store.js';
import { useClientCardStore } from '@/store/modules/clientCard/store.js';
import { useDashboardStore } from '@/store/modules/dashboard/store.js';
import { useFlowStore } from '@/store/modules/flow/store.js';
import { useUserCardStore } from '@/store/modules/userCard/store.js';
import { useLayoutStore } from '@/store/modules/layout/store.js';
import { useInterAccountLeadsStore } from '@/store/modules/interAccountLeads/store.js';
import { useUserStore } from '@/store/modules/user/store.js';

export function initStores() {
    useGlobalStore();
    useAccountCardStore();
    useAssociatedLeadsStore();
    useCalendarStore();
    useClientCardStore();
    useAccountStore();
    useContextStore();
    useDashboardStore();
    useFlowStore();
    useInterAccountLeadsStore();
    useLayoutStore();
    useUserCardStore();
    useUserStore();
}
